export enum OwnerType {
  Individual = 'individual',
  LegalEntity = 'legal_entity',
}
